module.exports = __webpack_public_path__ + "img/stock2.2b381afa.png";